"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UpDownLoadService = void 0;
const ChainRequest_1 = require("../../base/storyV2/response/customApiHandler/chain/ChainRequest");
const JsonUtil_1 = require("../../base/cutil/JsonUtil");
const LangUtil_1 = require("../../base/cutil/LangUtil");
const CustomApiTransformUtil_1 = require("../../base/storyV2/response/customApiHandler/util/CustomApiTransformUtil");
const GenUtil_1 = require("../../base/cutil/GenUtil");
const mime_db_1 = __importDefault(require("mime-db"));
class UpDownLoadService {
    constructor(brainClient) {
        this.brainClient = brainClient;
    }
    generateFilename(contentType) {
        const types = contentType?.split(";") || [];
        let comfirmedType = undefined;
        for (const type of types) {
            for (const [key, _displayType] of CustomApiTransformUtil_1.CustomApiTransformUtil.mimeTypesMap) {
                const regex = new RegExp(`^${key}`);
                if (regex.test(type.trim())) {
                    comfirmedType = type;
                }
            }
        }
        const extensions = mime_db_1.default[comfirmedType || "text/html"].extensions;
        const fileExtension = Array.from(extensions || []).first() || "html";
        return { name: GenUtil_1.GenUtil.randomString() + "." + fileExtension, format: fileExtension };
    }
    async upload(blob, fileInfo) {
        const data = new FormData();
        data.append("file", blob, "aa.");
        const res = await this.brainClient.openAi.upload(data);
        const s3Url = res?.data?.object_s3_url || res?.data?.s3_https_url || "";
        const uuid = res?.data?.uuid;
        const initCreateBlobUrl = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultInitCreateBlobUrl(), {
            objectURL: URL.createObjectURL(blob),
            loading: false,
            streaming: false,
        }) || new ChainRequest_1.ChainResultInitCreateBlobUrl();
        const textAreaValue = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultTextAreaValue(), {
            loading: false,
            s3Url,
            s3Path: res?.data?.object_key,
            needToCreateBlobUrl: `/api/me/upload/studios?url=${encodeURIComponent(s3Url)}`,
            uuid,
            name: fileInfo?.name,
            format: fileInfo?.format,
            value: s3Url,
        }) || new ChainRequest_1.ChainResultTextAreaValue();
        return { initCreateBlobUrl, textAreaValue };
    }
    async download(textAreaValue) {
        const result = await (0, LangUtil_1.tryPromise)(this.brainClient.openAi.download(textAreaValue.s3Url));
        if (result.data) {
            const blob = await result.data.data.blob();
            const initCreateBlobUrl = JsonUtil_1.JsonUtil.toModelFromInstance(new ChainRequest_1.ChainResultInitCreateBlobUrl(), {
                objectURL: URL.createObjectURL(blob),
                loading: false,
                streaming: false,
            }) || new ChainRequest_1.ChainResultInitCreateBlobUrl();
            return initCreateBlobUrl;
        }
        if (result.error) {
            console.error(new Error(result.error));
        }
    }
}
exports.UpDownLoadService = UpDownLoadService;
